import { render, staticRenderFns } from "./new-request.vue?vue&type=template&id=7ef7916a&scoped=true&"
import script from "./new-request.vue?vue&type=script&lang=js&"
export * from "./new-request.vue?vue&type=script&lang=js&"
import style0 from "./new-request.vue?vue&type=style&index=0&id=7ef7916a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef7916a",
  null
  
)

export default component.exports